export default __webpack_public_path__ + "static/media/settings.26300483.svg";